/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Flora Database API
 * Plant database management system
 * OpenAPI spec version: 1.0.0
 */
import type {
  PaginatedPlantList,
  PatchedPlantRequest,
  Plant,
  PlantRequest,
  PlantsListParams,
} from '../../model'

import { customInstance } from '../../axios-instance'
import type { BodyType } from '../../axios-instance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const getPlants = () => {
  /**
 * ViewSet for Plant model with filtering and search capabilities.
Requires authentication for write operations.
 */
  const plantsList = (
    params?: PlantsListParams,
    options?: SecondParameter<typeof customInstance<PaginatedPlantList>>
  ) => {
    return customInstance<PaginatedPlantList>(
      { url: `/api/plants/`, method: 'GET', params },
      options
    )
  }
  /**
 * ViewSet for Plant model with filtering and search capabilities.
Requires authentication for write operations.
 */
  const plantsCreate = (
    plantRequest: BodyType<PlantRequest>,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      {
        url: `/api/plants/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plantRequest,
      },
      options
    )
  }
  /**
 * ViewSet for Plant model with filtering and search capabilities.
Requires authentication for write operations.
 */
  const plantsRetrieve = (id: number, options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/${id}/`, method: 'GET' }, options)
  }
  /**
 * ViewSet for Plant model with filtering and search capabilities.
Requires authentication for write operations.
 */
  const plantsUpdate = (
    id: number,
    plantRequest: BodyType<PlantRequest>,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      {
        url: `/api/plants/${id}/`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: plantRequest,
      },
      options
    )
  }
  /**
 * ViewSet for Plant model with filtering and search capabilities.
Requires authentication for write operations.
 */
  const plantsPartialUpdate = (
    id: number,
    patchedPlantRequest: BodyType<PatchedPlantRequest>,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      {
        url: `/api/plants/${id}/`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: patchedPlantRequest,
      },
      options
    )
  }
  /**
 * ViewSet for Plant model with filtering and search capabilities.
Requires authentication for write operations.
 */
  const plantsDestroy = (id: number, options?: SecondParameter<typeof customInstance<void>>) => {
    return customInstance<void>({ url: `/api/plants/${id}/`, method: 'DELETE' }, options)
  }
  /**
   * Add or update a source URL for a plant.
   */
  const plantsAddSourceUrlCreate = (
    id: number,
    plantRequest: BodyType<PlantRequest>,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      {
        url: `/api/plants/${id}/add_source_url/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plantRequest,
      },
      options
    )
  }
  /**
   * Get all regional source data (DCR, Plant NOVA) for a specific plant.
   */
  const plantsSourceDataRetrieve = (
    id: number,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>({ url: `/api/plants/${id}/source_data/`, method: 'GET' }, options)
  }
  /**
   * Get all source URLs for a specific plant.
   */
  const plantsSourceUrlsRetrieve = (
    id: number,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>({ url: `/api/plants/${id}/source_urls/`, method: 'GET' }, options)
  }
  /**
   * Bulk update visual/design fields for a plant.
   */
  const plantsUpdateVisualDataCreate = (
    id: number,
    plantRequest: BodyType<PlantRequest>,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      {
        url: `/api/plants/${id}/update_visual_data/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plantRequest,
      },
      options
    )
  }
  /**
   * Get gallery images for a specific plant (public, read-only).
   */
  const plantsGalleryRetrieve = (
    plantId: number,
    options?: SecondParameter<typeof customInstance<void>>
  ) => {
    return customInstance<void>({ url: `/api/plants/${plantId}/gallery/`, method: 'GET' }, options)
  }
  /**
 * Serve compressed artwork for a plant.
Browser automatically decompresses when it sees Content-Encoding: gzip.

Query params:
    variant: Variant number (1, 2, or 3). Defaults to primary variant or variant 1.
    quality: 'original' or 'simplified'. Defaults to 'simplified'.
 */
  const plantsSvgRetrieve = (
    plantId: number,
    options?: SecondParameter<typeof customInstance<void>>
  ) => {
    return customInstance<void>({ url: `/api/plants/${plantId}/svg/`, method: 'GET' }, options)
  }
  /**
   * Get all plants without pagination for workflow view with full field data.
   */
  const plantsAllRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/all/`, method: 'GET' }, options)
  }
  /**
 * Batch update curation_rank for multiple plants.

Accepts: {"changes": [{"id": 12, "curation_rank": 1}, ...]}
Returns: {"updated": N}
 */
  const plantsBatchCurationRankCreate = (
    plantRequest: BodyType<PlantRequest>,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      {
        url: `/api/plants/batch-curation-rank/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plantRequest,
      },
      options
    )
  }
  /**
 * Match a list of plant names against the database.

Checks each name against: scientific_name, common_name,
alternative_scientific_names, and alternative_common_names.
Returns matched plants with full serializer data + match_type.
 */
  const plantsBulkMatchCreate = (
    plantRequest: BodyType<PlantRequest>,
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      {
        url: `/api/plants/bulk_match/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plantRequest,
      },
      options
    )
  }
  /**
   * Export all plants to CSV file using dynamic field introspection.
   */
  const plantsExportCsvRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/export_csv/`, method: 'GET' }, options)
  }
  /**
   * Fetch and scrape Alliance for the Chesapeake Bay Native Plant Center data.
   */
  const plantsFetchChesapeakeBayRetrieve = (
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      { url: `/api/plants/fetch_chesapeake_bay/`, method: 'GET' },
      options
    )
  }
  /**
   * Fetch and scrape plant data from UF/IFAS EDIS.
   */
  const plantsFetchEdisRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/fetch_edis/`, method: 'GET' }, options)
  }
  /**
   * Fetch and scrape Florida Wildflowers data using pre-built index or direct URL.
   */
  const plantsFetchFloridaWildflowersRetrieve = (
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      { url: `/api/plants/fetch_florida_wildflowers/`, method: 'GET' },
      options
    )
  }
  /**
   * Fetch and scrape FNPS plant data from their base64 JSON format.
   */
  const plantsFetchFnpsRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/fetch_fnps/`, method: 'GET' }, options)
  }
  /**
   * Fetch plant data from Plants For A Future (PFAF).
   */
  const plantsFetchPfafRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/fetch_pfaf/`, method: 'GET' }, options)
  }
  /**
   * Fetch and scrape Regional Conservation (Institute for Regional Conservation) data.
   */
  const plantsFetchRegionalConservationRetrieve = (
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      { url: `/api/plants/fetch_regional_conservation/`, method: 'GET' },
      options
    )
  }
  /**
 * Proxy USDA PLANTS API to avoid browser CORS restrictions.

Accepts: ?scientific_name=Quercus virginiana
Returns: { search: [...], profile: {...}, characteristics: [...] }
 */
  const plantsFetchUsdaRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/fetch_usda/`, method: 'GET' }, options)
  }
  /**
   * Fetch comprehensive plant data from USDA PLANTS database API.
   */
  const plantsFetchUsdaCharacteristicsRetrieve = (
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      { url: `/api/plants/fetch_usda_characteristics/`, method: 'GET' },
      options
    )
  }
  /**
   * Fetch and scrape USF Atlas of Florida Plants data.
   */
  const plantsFetchUsfAtlasRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/fetch_usf_atlas/`, method: 'GET' }, options)
  }
  /**
   * Fetch and scrape Digital Atlas of Virginia Flora data.
   */
  const plantsFetchVaAtlasRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/fetch_va_atlas/`, method: 'GET' }, options)
  }
  /**
   * Fetch plant data from wildflower.org (Lady Bird Johnson Wildflower Center).
   */
  const plantsFetchWildflowerOrgRetrieve = (
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>(
      { url: `/api/plants/fetch_wildflower_org/`, method: 'GET' },
      options
    )
  }
  /**
   * Get plants with missing required data for verification.
   */
  const plantsMissingDataRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/missing_data/`, method: 'GET' }, options)
  }
  /**
   * Search pre-built indexes for matching plant URLs using fuzzy matching.
   */
  const plantsSearchSourceUrlsRetrieve = (
    options?: SecondParameter<typeof customInstance<Plant>>
  ) => {
    return customInstance<Plant>({ url: `/api/plants/search_source_urls/`, method: 'GET' }, options)
  }
  const plantsSnapshotBundleRetrieve = (options?: SecondParameter<typeof customInstance<void>>) => {
    return customInstance<void>({ url: `/api/plants/snapshot-bundle/`, method: 'GET' }, options)
  }
  /**
   * Get database statistics.
   */
  const plantsStatsRetrieve = (options?: SecondParameter<typeof customInstance<Plant>>) => {
    return customInstance<Plant>({ url: `/api/plants/stats/`, method: 'GET' }, options)
  }
  /**
 * Bundle all plant SVGs into a single zip for bulk download.
Returns a zip containing SVG files named by plant ID (e.g. plant_212.svg)
plus a manifest.json with metadata (updated_at, scale, offsets, format).

Query params:
    since: ISO timestamp — only include variants updated after this time.
    quality: 'original' or 'simplified' (default: 'simplified').
 */
  const plantsSvgBundleRetrieve = (options?: SecondParameter<typeof customInstance<void>>) => {
    return customInstance<void>({ url: `/api/plants/svg-bundle/`, method: 'GET' }, options)
  }
  return {
    plantsList,
    plantsCreate,
    plantsRetrieve,
    plantsUpdate,
    plantsPartialUpdate,
    plantsDestroy,
    plantsAddSourceUrlCreate,
    plantsSourceDataRetrieve,
    plantsSourceUrlsRetrieve,
    plantsUpdateVisualDataCreate,
    plantsGalleryRetrieve,
    plantsSvgRetrieve,
    plantsAllRetrieve,
    plantsBatchCurationRankCreate,
    plantsBulkMatchCreate,
    plantsExportCsvRetrieve,
    plantsFetchChesapeakeBayRetrieve,
    plantsFetchEdisRetrieve,
    plantsFetchFloridaWildflowersRetrieve,
    plantsFetchFnpsRetrieve,
    plantsFetchPfafRetrieve,
    plantsFetchRegionalConservationRetrieve,
    plantsFetchUsdaRetrieve,
    plantsFetchUsdaCharacteristicsRetrieve,
    plantsFetchUsfAtlasRetrieve,
    plantsFetchVaAtlasRetrieve,
    plantsFetchWildflowerOrgRetrieve,
    plantsMissingDataRetrieve,
    plantsSearchSourceUrlsRetrieve,
    plantsSnapshotBundleRetrieve,
    plantsStatsRetrieve,
    plantsSvgBundleRetrieve,
  }
}
export type PlantsListResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsList']>>
>
export type PlantsCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsCreate']>>
>
export type PlantsRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsRetrieve']>>
>
export type PlantsUpdateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsUpdate']>>
>
export type PlantsPartialUpdateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsPartialUpdate']>>
>
export type PlantsDestroyResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsDestroy']>>
>
export type PlantsAddSourceUrlCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsAddSourceUrlCreate']>>
>
export type PlantsSourceDataRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsSourceDataRetrieve']>>
>
export type PlantsSourceUrlsRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsSourceUrlsRetrieve']>>
>
export type PlantsUpdateVisualDataCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsUpdateVisualDataCreate']>>
>
export type PlantsGalleryRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsGalleryRetrieve']>>
>
export type PlantsSvgRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsSvgRetrieve']>>
>
export type PlantsAllRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsAllRetrieve']>>
>
export type PlantsBatchCurationRankCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsBatchCurationRankCreate']>>
>
export type PlantsBulkMatchCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsBulkMatchCreate']>>
>
export type PlantsExportCsvRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsExportCsvRetrieve']>>
>
export type PlantsFetchChesapeakeBayRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchChesapeakeBayRetrieve']>>
>
export type PlantsFetchEdisRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchEdisRetrieve']>>
>
export type PlantsFetchFloridaWildflowersRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchFloridaWildflowersRetrieve']>>
>
export type PlantsFetchFnpsRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchFnpsRetrieve']>>
>
export type PlantsFetchPfafRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchPfafRetrieve']>>
>
export type PlantsFetchRegionalConservationRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchRegionalConservationRetrieve']>>
>
export type PlantsFetchUsdaRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchUsdaRetrieve']>>
>
export type PlantsFetchUsdaCharacteristicsRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchUsdaCharacteristicsRetrieve']>>
>
export type PlantsFetchUsfAtlasRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchUsfAtlasRetrieve']>>
>
export type PlantsFetchVaAtlasRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchVaAtlasRetrieve']>>
>
export type PlantsFetchWildflowerOrgRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsFetchWildflowerOrgRetrieve']>>
>
export type PlantsMissingDataRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsMissingDataRetrieve']>>
>
export type PlantsSearchSourceUrlsRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsSearchSourceUrlsRetrieve']>>
>
export type PlantsSnapshotBundleRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsSnapshotBundleRetrieve']>>
>
export type PlantsStatsRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsStatsRetrieve']>>
>
export type PlantsSvgBundleRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPlants>['plantsSvgBundleRetrieve']>>
>
